<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <!-- top buttons -->
      <div class="col-sm-12">
        <div class="card mb-4">
          <span class="top-actions">
            <!--  -->
            <h2 class="merge">{{ this.store_name }} .</h2>
          </span>
        </div>
      </div>
      <!-- end top buttons -->

      <div class="col-sm-12">
        <!-- table start -->
        <div class="card mb-4">
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <nav>
                <!-- <Search :PlaceHolder="placeHolderText" @search="handleSearch" /> -->
                <Search
                  :placeholder="placeHolderText"
                  @onsearch="handleSearch"
                />
              </nav>
              <table class="table align-items-center mb-0 view-container">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      #s/n
                    </th>

                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Item Name
                    </th>

                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Batch Number
                    </th>

                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Available qty
                    </th>

                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Buying Prc
                    </th>

                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Standard S.Prc
                    </th>

                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Expiry Date
                    </th>

                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Actions
                    </th>
                  </tr>
                </thead>

                <div v-if="tableLoading">
                  <div class="loader" v-if="apiLoading">
                    <div class="spinner"></div>
                    <p>Loading...</p>
                  </div>
                </div>

                <tbody v-if="users.length">
                  <tr v-for="user in users" :key="user.id">
                    <td>#{{ user.id }}</td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">
                            <itemname
                              :ItemName="user.item_name"
                              :ItemBrand="user.brand_name"
                              :ItemStrength="user.item_strength"
                            />
                          </h6>
                          <p class="text-xs text-secondary mb-0">
                            {{ user.category_name }} - {{ user.class_name }}
                          </p>
                        </div>
                      </div>
                    </td>

                    <td>
                      <input
                        size="10"
                        :id="user.id + 'batch'"
                        :ref="user.id + 'batchRef'"
                        :value="user.batch_number"
                        name="batch_number"
                      />
                      <!-- {{ user.batch_number }} -->
                    </td>

                    <td>
                      <input
                        size="10"
                        :id="user.id + 'qty'"
                        :ref="user.id + 'qtyRef'"
                        :value="user.quantity"
                        name="quantity"
                      />
                    </td>

                    <td>
                      {{ user.purchase_price }}
                    </td>

                    <td>
                      <input
                        size="10"
                        :id="user.id + 'cashCharge'"
                        :ref="user.id + 'cashChargeRef'"
                        :value="user.cash_charge"
                        name="cash_charge"
                      />
                    </td>

                    <td>
                      <input
                        type="date"
                        size="10"
                        :id="user.id + 'cashCharge'"
                        :ref="user.id + 'expiryRef'"
                        :value="user.expiry_date"
                        name="cash_charge"
                      />
                      <!-- {{ user.expiry_date }} -->
                    </td>

                    <td>
                      <button v-on:click="update_batch(user.id)">update</button>
                      .
                      <button
                        v-on:click="delete_batch(user.id)"
                        class="mycustom-danger-button"
                      >
                        delete
                      </button>
                    </td>
                  </tr>
                </tbody>
                <div v-else>
                  <p class="tocenter-container" v-if="!apiLoading">
                    No Records found.
                  </p>
                </div>
              </table>
              <!-- Pagination   @page-change="handlePageChange" :current-page="currentPage" :total-pages="totalPags" -->
              <!-- <pagination :all-data="allData" @content-change="handleContentChange" /> -->
              <div v-if="apiLoading">Loading...</div>
              <pagination
                v-if="!apiLoading"
                :all-data="allData"
                @content-change="handleContentChange"
                @loader-set="loaderSet"
              />

              <!--  -->
            </div>
          </div>
        </div>
        <!-- table end -->
      </div>
    </div>
  </div>

  <!-- <CreateItemModal /> -->
  <StockUploadModal />
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
import Pagination from "../components/pagination.vue";
import Search from "../components/search.vue";
import Itemname from "./components/ItemName.vue";
// import CreateItemModal from "./modals/createItem.vue";
import StockUploadModal from "./modals/stockUpload.vue";
//import axios from "axios";
import showNotification from "../../notification/notify";

export default {
  name: "itemstockdetails",
  data() {
    return {
      users: [],
      allData: {},
      apiLoading: true,
      tableLoading: true,
      placeHolderText: "Search Item...",
      selected_store: null,
      store_name: "",
      store_list: [],
    };
  },
  components: {
    Pagination,
    Search,
    Itemname,
    // CreateItemModal,
    StockUploadModal,
  },

  methods: {
    async handleSearch(searchTerm) {
      //console.log("the serch rem is " +searchTerm);
      try {
        this.apiLoading = true;
        const url =
          "inventory/search_stock_detail/" + this.$route.params.storeLocation;
        const body = { search_param: searchTerm };

        const rs = await generalApiRequest(url, "GET", body, 1);
        console.log(rs);
        this.allData = rs.data;
        this.apiLoading = false;
        // console.log(this.allData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    handleContentChange(contents) {
      // console.log("procceds");
      // console.log(contents);
      this.users = contents;
    },

    loaderSet(value) {
      if (value == true) {
        this.users = [];
      }
      this.tableLoading = value;
      //console.log(value);
      //this.apiLoading = value;
    },

    async changeStore(e) {
      this.apiLoading = true;
      this.selected_store = e.target.value;
      //console.log(e.target.value);
      this.$router.push("/item_stock/" + e.target.value);

      const storeLocation = e.target.value;
      //const url = 'inventory/getAllCompanyItems'; //?page=1 item_stock/storeLocation
      const url = "inventory/get_stock_overview/" + storeLocation;
      const body = {};

      const data = await generalApiRequest(url, "GET", body, 1);
      this.allData = data;
      this.apiLoading = false;
    },

    async update_batch(id) {
      var quantity = this.$refs[id + "qtyRef"].value;
      //var batch = this.$refs[id+'batchRef'].value;
      var cash_charge = this.$refs[id + "cashChargeRef"].value;
      var expiry = this.$refs[id + "expiryRef"].value;
      var batch = this.$refs[id + "batchRef"].value;

      try {
        const body = {
          quantity: quantity,
          cash_charge: cash_charge,
          expiry: expiry,
          batch: batch,
        }; // batch:batch,
        console.log(body);

        const url = "inventory/update_stock/" + id;

        const res = await generalApiRequest(url, "POST", body, 1);
        console.log(res);
        showNotification("Update Successful!");
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async delete_batch(id) {
      try {
        const confirmed = window.confirm(
          "Are you sure you want to delete this batch?"
        );
        if (!confirmed) return; // user cancelled

        const url = "inventory/delete_stock/" + id;
        const body = {};
        const res = await generalApiRequest(url, "POST", body, 1);
        console.log(res);

        // ✅ remove from local state
        this.users = this.users.filter((user) => user.id !== id);
        showNotification("Deleted Successfully!");
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    // async delete_batch(id) {
    //   try {
    //     const url = "inventory/delete_stock/" + id;
    //     const body = {};
    //     const res = await generalApiRequest(url, "POST", body, 1);
    //     console.log(res);

    //     // ✅ remove item from local state
    //     this.users = this.users.filter((user) => user.id !== id);
    //     showNotification("Deleted Successfully!");
    //   } catch (error) {
    //     console.error("Error fetching data:", error);
    //   }
    // },

    async get_stores_list() {
      //store_id
      try {
        const url = "inventory/getCompanyItemStores_for_input";
        const body = {};

        // const data = await getMethodRequest(url, body, 1);
        const store_list = await generalApiRequest(url, "GET", body, 1);
        // console.log(store_list);
        store_list.data.forEach((element) => {
          // console.log(element.id+" - "+this.$route.params.storeLocation);
          // console.log(element);

          if (element.id == this.$route.params.storeLocation) {
            this.store_name = element.store_name;
          }
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async callApi() {
      try {
        const storeLocation = this.$route.params.storeLocation;
        //const url = 'inventory/getAllCompanyItems'; //?page=1 item_stock/storeLocation
        const url = "inventory/get_stock_detail/" + storeLocation;
        const body = {};

        // const data = await getMethodRequest(url, body, 1);
        const data = await generalApiRequest(url, "GET", body, 1);
        // console.log(data);
        this.allData = data.data;
        this.apiLoading = false;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
  },

  mounted() {
    this.callApi();
    this.get_stores_list();
  },
};
</script>

<style scoped>
.merge {
  padding-right: "30px";
}
.view-container {
  max-width: 90vw;
}
.width-limit {
  width: "5px";
}
</style>
